import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import useSignup from "../../common/hooks/pages/useSignup";
import ForgotPassword from "../components/ForgotPassword";

function ForgotPasswordContainer() {
  const { toast } = usePopup();

  const { forgotPassword } = useSignup();

  const { mutate, isLoading } = useMutation({
    mutationFn: forgotPassword,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success", 10000);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message || "Something went wrong while login!";
      toast(message, "error");
    },
  });

  return (
    <ForgotPassword
      onSubmit={(data) => mutate(data)}
      isSubmitting={isLoading}
    />
  );
}

export default ForgotPasswordContainer;
